import { createContext } from "react";

type ModelIdContextProps = {
  modelId: string | undefined;
  setModelId: (modelId: string | undefined) => void;
};

export const Context = createContext<ModelIdContextProps | null>(null);
